export const JMU_DARK_PURPLE = "#450084";
export const JMU_GOLD = "#CBB677";

export function mod(n: number, m: number) {
  return ((n % m) + m) % m;
}